import { useCallback, useState } from "react"

import { useNavigate, useParams } from "react-router-dom"

import { useTranslation } from "@l2r-front/l2r-i18n"
import { FilterBottomSheet, useIsMobileDevice } from "@l2r-front/l2r-ui"
import { useNavigateWithSearchParams, useUrlParams } from "@l2r-front/l2r-utils"

import { I18N_NAMESPACE } from "../../../../common/constants/i18n"
import { VerticalSignsSidebarComponents } from "../../components/VerticalSignsSidebarComponents"
import { VERTICAL_SIGNING_CONDITION_URL_PARAM, VERTICAL_SIGNING_CODE_URL_PARAM } from "../../constants/urlParams"
import { useVerticalSigningStateContext } from "../../contexts/VerticalSigningContext"
import { useGetVerticalSignTypeCatalogUtils } from "../../hooks/utils/useGetVerticalSignTypeCatalogUtils"

import { VerticalSignFilters } from "../VerticalSignFilters"

import * as Styled from "./VerticalSigningMobileContent.styled"

export const VerticalSigningMobileContent = () => {

    const { getVerticalSignTypeDepth, getVerticalSignTypeChildren } = useGetVerticalSignTypeCatalogUtils()
    const navigateWithSearchParams = useNavigateWithSearchParams()
    const navigate = useNavigate()
    const { getParam, getParams } = useUrlParams()
    const { t } = useTranslation(I18N_NAMESPACE)
    const { code, road } = useParams()
    const [displayFilters, setDisplayFilters] = useState(false)
    const closeFilters = () => setDisplayFilters(false)
    const isMobile = useIsMobileDevice()
    const { ascendantCodes, filters } = useVerticalSigningStateContext()

    const handleChangeFilter = useCallback((filters) => {
        const filterCodeDepth = getVerticalSignTypeDepth(filters.type)
        const children = getVerticalSignTypeChildren(filters.type)
        if (filterCodeDepth % 2 === 1 && children.length > 1) {
            const condition = getParam(VERTICAL_SIGNING_CONDITION_URL_PARAM)
            navigateWithSearchParams(`./code/${filters.type}?${VERTICAL_SIGNING_CODE_URL_PARAM}=${filters.type}${condition ? `&${VERTICAL_SIGNING_CONDITION_URL_PARAM}=${condition}` : ""}`)
        }
    }, [getParam, getVerticalSignTypeDepth, getVerticalSignTypeChildren, navigateWithSearchParams])

    const handleBack = useCallback(() => {
        const filterCodeDepth = getVerticalSignTypeDepth(filters.type)

        if (code && filterCodeDepth % 2 === 0) {
            const searchParams = getParams()
            searchParams.set(VERTICAL_SIGNING_CODE_URL_PARAM, ascendantCodes[1])
            const newParams = Array.from(searchParams.entries()).reduce((acc, [key, value]) => {
                return `${acc}${key}=${value}&`
            }, "?")
                .slice(0, -1)
            navigate(road ? `../${road}${newParams}` : `../${newParams}`)
        } else {
            navigateWithSearchParams("../")
        }
    }, [ascendantCodes, filters, getParams, getVerticalSignTypeDepth, navigate, navigateWithSearchParams, road, code])

    return (
        <>
            <Styled.BottomSheetContent
                id="vertical-signing-mobile-content"
                isMobile={isMobile}
                onBack={code || road ? handleBack : null}
                title={t(I18N_NAMESPACE, `containers.verticalSigningSidebar.${road ? "roadTitle" : "title"}`)}>
                <VerticalSignsSidebarComponents handleChangeTypeFilter={handleChangeFilter} />
            </Styled.BottomSheetContent>
            <FilterBottomSheet open={displayFilters} onClose={closeFilters}>
                <VerticalSignFilters displayFilters={displayFilters} close={closeFilters} />
            </FilterBottomSheet>
        </>
    )
}